import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreAction } from "../../@core/constants/action";

// Get All Staff List
export const getAllStaffAction = createAsyncThunk(
  "",
  async (staffList, { dispatch }) =>
    dispatch({ type: StoreAction.GET_ALL_STAFF_LIST, payload: staffList })
);

// Create New Staff
export const insertStaffAction = createAsyncThunk(
  "",
  async (staffData, { dispatch, getState }) => {
    const state = getState();
    return dispatch({
      type: StoreAction.GET_ALL_STAFF_LIST,
      payload: [...state.commonReducer.staffList, { ...staffData }],
    });
  }
);

// Update Staff
export const updateStaffAction = createAsyncThunk(
  "",
  async (staffData, { dispatch, getState }) => {
    const state = getState();
    const allStaff = state.commonReducer.staffList;
    const newStaffList = allStaff.map((staff) => {
      return staff.u_id == staffData?.u_id ? (staff = staffData) : staff;
    });
    return dispatch({
      type: StoreAction.GET_ALL_STAFF_LIST,
      payload: newStaffList,
    });
  }
);

// Set Websocket in redux
export const setWebSocketAction = createAsyncThunk(
  "",
  async (webSocket, { dispatch }) =>
    dispatch({ type: StoreAction.SET_WEB_SOCKET, payload: webSocket })
);

// Get Customer Label List
export const getCustomerLabelListAction = createAsyncThunk(
  "",
  async (labelList, { dispatch }) =>
    dispatch({
      type: StoreAction.GET_ALL_CUSTOMER_LABEL_LIST,
      payload: labelList,
    })
);

// Add Customer Label
export const insertCustomerLabelAction = createAsyncThunk(
  "",
  async (labelData, { dispatch, getState }) => {
    const state = getState();
    dispatch({
      type: StoreAction.GET_ALL_CUSTOMER_LABEL_LIST,
      payload: [...state.commonReducer.customerLabelList, { ...labelData }],
    });
  }
);

// Update Customer Label
export const updateCustomerLabelAction = createAsyncThunk(
  "",
  async (labelData, { dispatch, getState }) => {
    const state = getState();
    const allLabels = state.commonReducer.customerLabelList;
    const updateLabelList = allLabels?.map((label) => {
      return label?.a_id == labelData?.a_id ? (label = labelData) : label;
    });
    return dispatch({
      type: StoreAction.GET_ALL_CUSTOMER_LABEL_LIST,
      payload: updateLabelList,
    });
  }
);

// Delete Customer Label
export const deleteCustomerLabelAction = createAsyncThunk(
  "",
  async (id, { dispatch, getState }) => {
    const state = getState();
    const allLabels = state.commonReducer.customerLabelList;
    const updateLabelList = allLabels?.filter((label) => label?.a_id != id);
    return dispatch({
      type: StoreAction.GET_ALL_CUSTOMER_LABEL_LIST,
      payload: updateLabelList,
    });
  }
);

export const setIsSubmittingAction = createAsyncThunk(
  "",
  async (isSubmitting, { dispatch }) =>
    dispatch({ type: StoreAction.SET_IS_SUBMITTING, payload: isSubmitting })
);

export const addPendingRequestAction = createAsyncThunk(
  "",
  async (request, { dispatch, getState }) => {
    const state = getState();
    return dispatch({
      type: StoreAction.PENDING_REQUEST,
      payload: [...state.commonReducer.pendingRequests, request],
    });
  }
);

export const removePendingRequestAction = createAsyncThunk(
  "",
  async (requestId, { dispatch, getState }) => {
    const state = getState();
    const updatedPendingRequest = state.commonReducer.pendingRequests.filter(
      (req) => req.requestId !== requestId
    );

    return dispatch({
      type: StoreAction.PENDING_REQUEST,
      payload: updatedPendingRequest,
    });
  }
);
